import {useEffect} from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "./AuthProvider";

const Logout = () => {
    const {logout, isAuthenticated} = useAuth();

    useEffect(() => {
        logout();
    }, [logout]);

    return isAuthenticated ? null : <Navigate to="/login" replace />;
};

export default Logout;
